import useStore from "@store/store";
import { useShallow } from "zustand/react/shallow";

/**
 * @description 로그인 모달 관련 훅
 * useLoginModalOpen: 로그인 모달 열림 상태 반환
 * useLoginModalActions: 로그인 모달 열기/닫기 액션 반환
 */

export const useLoginModalOpen = () => useStore((state) => state.view);
export const useLoginModalActions = () =>
  useStore(
    useShallow((state) => ({
      setOpen: state.setOpen,
      setClose: state.setclose,
    }))
  );
